module.exports = __webpack_public_path__ + "static/q15_o-36d82d2dc4580c7d51a0da37b5e445cb.png";